import {
  GrowthBook,
  GrowthBookProvider as BaseGrowthBookProvider,
  type Context,
  GrowthBookContext,
  type Experiment,
  type Result,
} from '@growthbook/growthbook-react'
import * as React from 'react'

export const initABTesting = (options: Context) => {
  const abTester = new GrowthBook(options)

  const ABTestingProvider = ({
    children,
  }: React.PropsWithChildren<unknown>) => {
    return (
      <BaseGrowthBookProvider growthbook={abTester}>
        {children}
      </BaseGrowthBookProvider>
    )
  }

  return { ABTestingProvider, abTester }
}

// Why not the default "useExperiment"?

// The default `useExperiment` hook doesn't wrap `growthbook.run` in an
// effect. This is a problem because `growthbook.run` fires growthbook subscriptions
// and if we use these subscriptions to update any react state or trigger re-renders 💥

export function useExperiment<T>(config: Experiment<T>): Result<T> {
  const { growthbook } = React.useContext(GrowthBookContext)

  const resultRef = React.useRef(
    // @ts-expect-error: using private `_run` to avoid firing subscriptions
    growthbook?._run(config) ?? {
      featureId: null,
      value: config.variations[0],
      variationId: 0,
      inExperiment: false,
      hashUsed: false,
      hashAttribute: config.hashAttribute || 'id',
      hashValue: '',
    }
  )

  React.useEffect(() => {
    if (growthbook) {
      resultRef.current = growthbook.run(config)
    }
  })

  return resultRef.current
}

export {
  IfFeatureEnabled,
  FeatureString,
  withRunExperiment,
} from '@growthbook/growthbook-react'

export type {
  GrowthBook as ABTester,
  Experiment,
  Result,
} from '@growthbook/growthbook-react'
